import Vue from "vue";
import { ajax } from "@/plugins/ajax";
import maxIndex from "./maxIndex";

export default {
  namespaced: true,
  state: {
    model: {
      storeId: null,
      requesterInfoCommand: { requesterId: "1", requesterName: "Admin" },
      draftOrderInfoCommand: {
        draftOrderId: null,
        dischargePermissionId: null
      },
      registerClock: null,
      automationCode: null,
      description: null,
      checkType: 0,
      inventoryTransactionItemCommands: []
    },
    selectedTransactionIndex: null
  },
  getters: {
    model: state => state.model,
    inventoryTransactions: state =>
      state.model.inventoryTransactionItemCommands,
    selectedTransactionSerials: state => {
      var transaction =
        state.model.inventoryTransactionItemCommands[
          state.selectedTransactionIndex
        ];
      return transaction && transaction.serialsInfo
        ? transaction.serialsInfo
        : [];
    },
    selectedTransactionSerialsCountLessThanEnteredCount: state => {
      var transaction =
        state.model.inventoryTransactionItemCommands[
          state.selectedTransactionIndex
        ];
      if (transaction && transaction.count == 0) {
        return false;
      }
      return transaction && transaction.serialsInfo
        ? transaction.serialsInfo.length < transaction.count
        : true;
    }
  },
  actions: {
    CheckOutPrint({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/CheckOutPrintQuery/" +
              model.transactionId +
              "/" +
              model.stockId
          )
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    CheckOutPrintForLable({ commit, dispatch }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .get(
            "Inventory/api/CheckOutPrintQuery/label/" +
              model.transactionId +
              "/" +
              model.stockId
          )
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    ReadInfoForWarrantyCard({ commit, state }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckOutPrintQuery/warranty-info", model)
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    printCompeleteOneRowDischarge({ commit, dispatch }, model) {
      return ajax
        .put("Inventory/api/DischargePermission/complete-print-a-row", model)
        .then(() => {
          dispatch("fetch");
        });
    },
    ReadInfoForLabelCard({ commit, state }, model) {
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckOutPrintQuery/print-label", model)
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    },
    printCompeleteOneRowDischarge({ commit, dispatch }, model) {
      return ajax
        .put("Inventory/api/DischargePermission/complete-print-a-row", model)
        .then(() => {
          dispatch("fetch");
        });
    },
    create({ commit, state }, finalModel) {
      ///set serial stock count 0 for backend api model
      // var finalModel = JSON.parse(JSON.stringify(state.model));
      // finalModel.inventoryTransactionItemCommands.forEach(a => {
      //   if (a.stockType == 1) {
      //     a.count = 0;
      //   }
      // });
      ////
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckOutTransactions", finalModel)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    createDischargeCheckOut({ commit, state }, finalModel) {
      ////
      return new Promise((resolve, reject) => {
        ajax
          .post("Inventory/api/CheckOutTransactions/DraftOrderInfo", finalModel)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    update({ commit, dispatch }, model) {
      return ajax
        .put("WarehousingManagement/api/Warehouses", model)
        .then(() => {
          dispatch("fetch");
        });
    },
    printCompeleteOneRow({ commit, dispatch }, model) {
      return ajax
        .put("Inventory/api/CheckOutTransactions/complete-print-a-row", model)
        .then(() => {
          dispatch("fetch");
        });
    },
    setModelHeaders({ commit }, model) {
      commit("setModelHeaders", model);
    },
    setDischargeModelHeaders({ commit }, model) {
      commit("setDischargeModelHeaders", model);
    },
    addTransaction({ commit, dispatch }, transaction) {
      commit("addTransaction", transaction);
    },
    updateTransactionCountInfo({ commit }, { index, count }) {
      commit("updateTransactionCountInfo", { index, count });
    },
    removeTransaction({ commit, dispatch }, transaction) {
      commit("removeTransaction", transaction);
    },
    addSerialToSelectedTransaction({ commit }, serialInfo) {
      commit("addSerialToSelectedTransaction", serialInfo);
    },
    addSerialToSelectedTransactionWithBarcode({ commit }, model) {
      commit("addSerialToSelectedTransactionWithBarcode", model);
    },
    removeSerialFromSelectedTransaction({ commit }, index) {
      commit("removeSerialFromSelectedTransaction", index);
    },
    removeAllSerialFromSelectedTransaction({ commit }, index) {
      commit("removeAllSerialFromSelectedTransaction", index);
    },
    setSelectedTransactionIndex({ commit }, index) {
      commit("setSelectedTransactionIndex", index);
    },
    checkSerialsCount({ state }) {
      var valid = true;
      state.model.inventoryTransactionItemCommands.forEach(a => {
        if (a.stockType == 1 || a.productType == "Serial") {
          if (!(!a.serials && a.count == 0)) {
            if (!a.serials || (a.serials && a.serials.length != a.count))
              valid = false;
          }
        }
      });
      return valid;
    },
    CheckOutTransactions({ commit, dispatch }, transactionId) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Inventory/api/CheckOutTransactionsQuery/" + transactionId)
          .then(r => {
            commit("setDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    }
  },
  mutations: {
    createModelEmpty(state) {
      state.model = {
        storeId: null,
        requesterInfoCommand: { requesterId: "1", requesterName: "Admin" },
        registerClock: null,
        automationCode: null,
        description: null,
        inventoryTransactionItemCommands: []
      };
    },
    setModelHeaders(state, data) {
      state.model = {
        ...state.model,
        storeId: data.storeId,
        registerClock: data.registerClock,
        automationCode: data.automationCode,
        requesterInfoCommand: data.requesterInfoCommand,
        description: data.description,
        cottageNumber: Number(data.cottageNumber),
        shipmentNumber: data.shipmentNumber,
        partyOwnerId: data.partyOwnerId,
        salePersonId: data.salePersonId
      };
    },
    setDischargeModelHeaders(state, data) {
      state.model = {
        ...state.model,
        storeId: data.storeId,
        registerClock: data.registerClock,
        automationCode: data.automationCode,
        requesterInfoCommand: data.requesterInfoCommand,
        draftOrderInfoCommand: data.draftOrderInfoCommand,
        description: data.description
      };
    },
    addTransaction(state, data) {
      state.model.inventoryTransactionItemCommands.push(data);
    },
    updateTransactionCountInfo(state, { index, count }) {
      var updatedValue = state.model.inventoryTransactionItemCommands[index];
      updatedValue.count = count;
      Vue.set(
        state.model.inventoryTransactionItemCommands,
        index,
        updatedValue
      );
    },
    removeTransaction(state, index) {
      state.model.inventoryTransactionItemCommands.splice(index, 1);
    },
    addSerialToSelectedTransactionWithBarcode(state, model) {
      var transaction;
      if (model.stockId) {
        for (
          let indexfind = 0;
          indexfind < state.model.inventoryTransactionItemCommands.length;
          indexfind++
        ) {
          if (
            state.model.inventoryTransactionItemCommands[indexfind].stockId ==
            model.stockId
          ) {
            transaction =
              state.model.inventoryTransactionItemCommands[indexfind];
            break;
          }
        }
      } else {
        transaction =
          state.model.inventoryTransactionItemCommands[model.rowNumber];
      }
      if (!transaction.serialsInfo) transaction.serialsInfo = [];
      if (typeof serialInfo == "object") {
        for (let index = 0; index < model.serialInfo.length; index++) {
          transaction.serialsInfo.push({
            serial: model.serialInfo[index].serial,
            index: maxIndex.findMaxIndex(
              state.model.inventoryTransactionItemCommands
            )
          });
        }
      } else {
        transaction.serialsInfo.push({
          serial: model.serialInfo,
          index: maxIndex.findMaxIndex(
            state.model.inventoryTransactionItemCommands
          )
        });
      }
      Vue.set(
        state.model.inventoryTransactionItemCommands,
        state.selectedTransactionIndex,
        transaction
      );
    },
    addSerialToSelectedTransaction(state, serialInfo) {
      var transaction =
        state.model.inventoryTransactionItemCommands[
          state.selectedTransactionIndex
        ];
      if (!transaction.serialsInfo) transaction.serialsInfo = [];
      if (typeof serialInfo == "object") {
        for (let index = 0; index < serialInfo.length; index++) {
          transaction.serialsInfo.push({
            serial: serialInfo[index].serial,
            index: maxIndex.findMaxIndex(
              state.model.inventoryTransactionItemCommands
            )
          });
        }
      } else {
        transaction.serialsInfo.push({
          serial: serialInfo,
          index: maxIndex.findMaxIndex(
            state.model.inventoryTransactionItemCommands
          )
        });
      }
      Vue.set(
        state.model.inventoryTransactionItemCommands,
        state.selectedTransactionIndex,
        transaction
      );
    },
    removeSerialFromSelectedTransaction(state, index) {
      var transaction =
        state.model.inventoryTransactionItemCommands[
          state.selectedTransactionIndex
        ];
      if (transaction && transaction.serialsInfo) {
        transaction.serialsInfo.splice(index, 1);
        Vue.set(
          state.model.inventoryTransactionItemCommands,
          state.selectedTransactionIndex,
          transaction
        );
      }
    },
    removeAllSerialFromSelectedTransaction(state, index) {
      var transaction = state.model.inventoryTransactionItemCommands[index];
      if (transaction && transaction.serialsInfo) {
        transaction.serialsInfo = [];
        Vue.set(
          state.model.inventoryTransactionItemCommands,
          state.selectedTransactionIndex,
          transaction
        );
      }
    },
    setSelectedTransactionIndex(state, index) {
      state.selectedTransactionIndex = index;
    }
  }
};
